'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * TextArea
 */
var TextareaField = function (_AbstractField) {
    (0, _inherits3.default)(TextareaField, _AbstractField);

    function TextareaField() {
        (0, _classCallCheck3.default)(this, TextareaField);
        return (0, _possibleConstructorReturn3.default)(this, (TextareaField.__proto__ || (0, _getPrototypeOf2.default)(TextareaField)).apply(this, arguments));
    }

    (0, _createClass3.default)(TextareaField, [{
        key: 'render',
        value: function render() {
            // Ignore componentClass
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter']);


            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'textarea'
            }, props));

            return this.renderFieldWithAddons(field, null, null);
        }
    }]);
    return TextareaField;
}(_AbstractField3.default);

TextareaField.PropTypes = {
    rows: _react2.default.PropTypes.number // počat řádek pro textareu
};
TextareaField.defaultProps = {
    rows: 3
};
exports.default = TextareaField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvVGV4dGFyZWFGaWVsZC5qc3giXSwibmFtZXMiOlsiVGV4dGFyZWFGaWVsZCIsInByb3BzIiwiYWRkb25zQmVmb3JlIiwiYWRkb25zQWZ0ZXIiLCJmaWVsZCIsInJlbmRlckZpZWxkV2l0aEFkZG9ucyIsIkFic3RyYWN0RmllbGQiLCJQcm9wVHlwZXMiLCJyb3dzIiwiUmVhY3QiLCJudW1iZXIiLCJkZWZhdWx0UHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7Ozs7QUFFQTs7O0lBR01BLGE7Ozs7Ozs7Ozs7aUNBU087QUFDTDtBQURLLHlCQUV5QyxLQUFLQyxLQUY5QztBQUFBLGdCQUVFQyxZQUZGLFVBRUVBLFlBRkY7QUFBQSxnQkFFZ0JDLFdBRmhCLFVBRWdCQSxXQUZoQjtBQUFBLGdCQUVnQ0YsS0FGaEM7OztBQUlMLGdCQUFNRyxRQUFRLDhCQUFDLGlCQUFEO0FBQ1Ysc0JBQUs7QUFESyxlQUVOSCxLQUZNLEVBQWQ7O0FBS0EsbUJBQU8sS0FBS0kscUJBQUwsQ0FBMkJELEtBQTNCLEVBQWtDLElBQWxDLEVBQXdDLElBQXhDLENBQVA7QUFDSDs7O0VBbkJ1QkUsdUI7O0FBQXRCTixhLENBQ0tPLFMsR0FBWTtBQUNmQyxVQUFNQyxnQkFBTUYsU0FBTixDQUFnQkcsTUFEUCxDQUNpQjtBQURqQixDO0FBRGpCVixhLENBS0tXLFksR0FBZTtBQUNsQkgsVUFBTTtBQURZLEM7a0JBZ0JYUixhIiwiZmlsZSI6IlRleHRhcmVhRmllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7SW5wdXR9IGZyb20gJ3JlYWN0c3RyYXAnXG5pbXBvcnQgQWJzdHJhY3RGaWVsZCBmcm9tIFwiLi9BYnN0cmFjdEZpZWxkXCI7XG5cbi8qKlxuICogVGV4dEFyZWFcbiAqL1xuY2xhc3MgVGV4dGFyZWFGaWVsZCBleHRlbmRzIEFic3RyYWN0RmllbGQge1xuICAgIHN0YXRpYyBQcm9wVHlwZXMgPSB7XG4gICAgICAgIHJvd3M6IFJlYWN0LlByb3BUeXBlcy5udW1iZXIsICAgLy8gcG/EjWF0IMWZw6FkZWsgcHJvIHRleHRhcmV1XG4gICAgfTtcblxuICAgIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgICAgIHJvd3M6IDNcbiAgICB9O1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICAvLyBJZ25vcmUgY29tcG9uZW50Q2xhc3NcbiAgICAgICAgY29uc3Qge2FkZG9uc0JlZm9yZSwgYWRkb25zQWZ0ZXIsIC4uLnByb3BzfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgY29uc3QgZmllbGQgPSA8SW5wdXRcbiAgICAgICAgICAgIHR5cGU9XCJ0ZXh0YXJlYVwiXG4gICAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIC8+O1xuXG4gICAgICAgIHJldHVybiB0aGlzLnJlbmRlckZpZWxkV2l0aEFkZG9ucyhmaWVsZCwgbnVsbCwgbnVsbCk7XG4gICAgfVxufVxuZXhwb3J0IGRlZmF1bHQgVGV4dGFyZWFGaWVsZDtcbiJdfQ==